import translate from "@/plugins/translate-field";
import { _moment as moment } from "@/utils/moment";

export class Formatter {
  price(value: number) {
    if (value) {
      let price = value / 100;
      return price.toLocaleString();
    } else {
      return 0;
    }
  }

  date(value: string | Date) {
    return moment(value).format("YYYY-MM-DD");
  }

  setPrice(value: number) {
    let price: number;
    if (value > 0) {
      let formattedPrice = new Intl.NumberFormat("ru-RU", {
        currency: "RUB",
        style: "currency"
      });

      let parsedPrice = formattedPrice
        .format(value)
        .toString()
        .replace(/\D/g, "");

      price = parseInt(parsedPrice);
    } else {
      price = 0;
    }
    return price;
  }

  getPrice(value: number) {
    return value / 100;
  }

  phone(value: any) {
    if (value) {
      let _value = value.replace(/\D+/g, "").replace(/^1/, "");

      if (_value.length === 11 && (+_value[0] === 7 || +_value[0] === 8)) {
        let _match = _value.match(/([^\d]*\d[^\d]*){1,10}$/)[0];
        const part1 =
          _match.length > 2 ? `(${_match.substring(0, 3)})` : _match;
        const part2 = _match.length > 3 ? ` ${_match.substring(3, 6)}` : "";
        const part3 = _match.length > 6 ? `-${_match.substring(6, 10)}` : "";
        return `+7 ${part1}${part2}${part3}`;
      } else {
        return value;
      }
    }
  }

  translate(value: string): string {
    return translate(value);
  }

  limitedOutput(label: string, count: number = 60): string {
    return label?.length > count ? label.slice(0, count) + "..." : label;
  }
}
